<template>
<v-card>
  <request-status :request='request' @ok="emit" />
  <v-card-title class='overline grey lighten-4 py-0' >
    Link a JotForm to AppointmentGuru
    <v-spacer></v-spacer>
    <v-btn @click='$emit("close")' small icon ><v-icon small >close</v-icon></v-btn>
  </v-card-title>
  <v-divider/>

    <p class='blue lighten-4 pa-2' >
      <v-subheader class='overline pa-0 ma-0'>Info:</v-subheader>
      When you link a JotForm to AppointmentGuru, you will be able to share the form with
      your AppointmentGuru clients and connect information from their form submissions
      to their client profile
    </p>

    <space-picker multiple
    v-model="spaces"
    label="Which spaces do you want to use this form in?"
    :with-select='false' />

    <v-card-text>
      <v-checkbox persistent-hint
        v-model="withLink"
        label="Link this form"
        hint="Include a link to this form in notifications, on the client appointment information page and in your appointment link page" />
    </v-card-text>

    <!-- <pre v-text='form' ></pre> -->
    <!-- <v-text-field v-model='form.title' label='Form name' >
    </v-text-field> -->

  <v-card-actions>
    <!-- <v-btn flat >Learn more
      <v-icon small class='ml-2' >open_in_new</v-icon>
    </v-btn> -->
    <v-spacer></v-spacer>
    <v-btn color='primary'
      @click='link(form.id)'
      :loading='request.loading' >Link form</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import SpacePicker from '@/components/pickers/SpacePicker.vue'
export default {
  name: 'HomeRelationships',
  components: {SpacePicker},
  props: {
    form: { type: Object, required: true }
  },
  data () {
    return {
      withLink: false,
      spaces: [],
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/link'
      }
    }
  },
  methods: {
    link (jotformId) {
      this.request.data = {
        jotform_id: jotformId,
        include_on_appointment_page: this.withLink,
        spaces: this.spaces.join(',')
      }
      this.$request('save', this.request)
    },
    emit (result) {
      this.$emit('success', result)
    }
  }
}
</script>



// WEBPACK FOOTER //
// LinkJotForm.vue?97914824